export default __webpack_public_path__ + "static/shutterstock_11-96bf4465bf0d31126c0ce723c8e4da7a.jpg";